import { useSoundObserver } from 'src/common/hooks/use-sound-observer';
import { useThemeObserver } from 'src/common/hooks/use-theme-observer';
export const ThemeObserverWrapper = () => {
  // Need to have a wrapper because of context errors
  useThemeObserver();
  useSoundObserver();
  return null;
};